import React, { useMemo } from 'react';
import { DefaultText, Container } from './ThirdPartiesSideModule.styles';
import { Collapsible } from 'components/atoms';
import SideModule from 'components/molecules/side-module';
import { useFormContext } from 'react-hook-form';
import { useTerminologyConfig } from 'context/DataContext';

const ThirdPartiesSideModule = ({ thirdPartiesData }) => {
  const terminologyConfig = useTerminologyConfig();
  const { getValues } = useFormContext();
  const selectedPartiesIds = getValues('linkedThirdParties');
  const thirdParties = useMemo(
    () =>
      thirdPartiesData?.filter((re) => {
        return selectedPartiesIds?.includes(re.id);
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedPartiesIds]
  );
  let result: JSX.Element;

  if (thirdParties.length === 0) {
    result = <DefaultText>No {terminologyConfig.thirdPartyPluralNaming} selected </DefaultText>;
  } else if (thirdParties.length <= 10) {
    result = (
      <>
        {thirdParties.map((linkedThirdParty) => (
          <Container key={linkedThirdParty.id}>
            {linkedThirdParty.name && <DefaultText>{`Name: ${linkedThirdParty.name}`}</DefaultText>}
            {linkedThirdParty.linkType && (
              <DefaultText>{`Relationship to ${terminologyConfig.thirdPartySingularNaming}: ${linkedThirdParty.linkType}`}</DefaultText>
            )}
          </Container>
        ))}
      </>
    );
  } else {
    const linkedThirdPartiesBeforeReadMore = 10;
    const shownLinkedThirdParties = thirdParties.slice(0, linkedThirdPartiesBeforeReadMore);
    const hiddenLinkedThirdParties = thirdParties.slice(linkedThirdPartiesBeforeReadMore);
    result = (
      <>
        {shownLinkedThirdParties.map((thirdParty) => (
          <Container key={thirdParty.id}>
            {thirdParty.name && <DefaultText>{`Name: ${thirdParty.name}`}</DefaultText>}
            {thirdParty.linkType && (
              <DefaultText>{`Relationship to ${terminologyConfig.thirdPartySingularNaming}: ${thirdParty.linkType}`}</DefaultText>
            )}
          </Container>
        ))}
        <Collapsible collapsedText="Read more" expandedText="Read less">
          {hiddenLinkedThirdParties.map((thirdParty) => (
            <Container key={thirdParty.id}>
              {thirdParty.name && <DefaultText>{`Name: ${thirdParty.name}`}</DefaultText>}
              {thirdParty.linkType && (
                <DefaultText>{`Relationship to ${terminologyConfig.thirdPartySingularNaming}: ${thirdParty.linkType}`}</DefaultText>
              )}
            </Container>
          ))}
        </Collapsible>
      </>
    );
  }

  return (
    <SideModule header={'Linked ' + terminologyConfig.thirdPartyPluralNaming}>{result}</SideModule>
  );
};

export default ThirdPartiesSideModule;
